jQuery( document ).ready( function( $ ) {
	fix_header();
	$( window ).scroll( function() {
		fix_header();
	} );
	if (typeof Freezeframe != "undefined") {
		$.each($('.freezeframe'), function(ix,val){
			if($(val).closest('.ub-slider').length===0){
				new Freezeframe({
					selector: val,
					trigger: 'click',
					overlay: true
				});
			}
		})
	}

	$('.skip-link').on('click', function (e) {
		e.preventDefault(); // Prevent default link behavior

		// Move focus to the target element
		const target = $($(this).attr('href'));
		if (target.length) {
			target.attr('tabindex', '-1').focus();

			// Remove tabindex after focus to allow natural tabbing
			target.on('blur', function () {
				$(this).removeAttr('tabindex');
			});
		}
	});


	$('.bundled_item_cart_content .product__details-quantity button').on('click', function(e){
		e.preventDefault()
		const action = $(this).attr('class');
		const qtyInput = $(this).siblings('.quantity ').find('input.qty')
		const min = $(qtyInput).attr('min')
		const max = $(qtyInput).attr('max')
		switch (action){
			case 'add':
				if($(qtyInput).val()<max) {
					$(qtyInput).val(parseInt($(qtyInput).val()) + 1)
				}

				break;

			case 'remove':
				if($(qtyInput).val()>min) {
					$(qtyInput).val($(qtyInput).val() - 1)
				}

				break;
		}



	})


	function fix_header() {
		const $body = $( 'body' ),
			$header = $( 'header' ),
			scroll = $( window ).scrollTop();

		if ( scroll >= 200 ) {
			$header.addClass( 'fixed' ); $body.addClass( 'fixed' );
		} else {
			$( '.fixed' ).removeClass( 'fixed' );
		}
	}

	$( '.nav__search-btn' ).on( 'click', function( e ) {

		const $this = $( this );
		const $thisNavSearch = $this.closest( '.nav__search' );
		const $thisSearch = $thisNavSearch.find( '.nav__search-search' );

		if ( $thisNavSearch.attr( 'aria-expanded' ) !== 'true' ) {
			$thisNavSearch.attr( 'aria-expanded', true );
			e.preventDefault();
			return false;
		} else if ( $thisSearch.val() == '' ) {
			$thisNavSearch.attr( 'aria-expanded', false );
			return false;
		}

	} );
	$( document ).on( 'submit','.ub-email-signup', function( e ) {
		e.preventDefault();
		const $form = $( this );
		const isFormValid = $form[ 0 ].checkValidity();
		$( '.ub-email-signup').next(' .ub-messages' ).remove();
		if ( ! isFormValid ) {
			$form[ 0 ].reportValidity();
		} else {
			e.preventDefault();
			$( '.ub-email-signup button' ).html( '<img src="/wp-content/themes/uppababy/assets/img/loading-icon-v1.svg" />' ).addClass( 'spinning' );
			$.ajax( {
				type: 'POST',
				url: ubData.ajaxurl,
				dataType: 'json',
				data: {
					action: 'ub_email_signup',
					values: $form.serialize(),
				},
				success( data ) {
					if ( 'success' in data ) {
						$form.html( data.success );
					} else {
						for(var i in data.errors){
							$( '.ub-email-signup input[name='+data.errors[i].name +']').addClass( 'error' );
							$( '.ub-email-signup' ).after( '<div class="ub-messages ub-errors"><p class="error">' + data.errors[ i ].error + '</p></div>' );
						}
						$( '.ub-email-signup button' ).html( 'Sign Up' ).removeClass( 'spinning' );
					}
				},
			} );
		}
	} );

	function get_registration_rest_endpoint( action = null ){
		switch (action) {
			case 'ub_registration_get_serial_details':
				endpoint = '/get_serial_details/'
				break;
			case 'ub_registration_get_manufacture_details':
				endpoint = '/manufacture_details/'
				break;
		
			default:
				endpoint = '/get_serial_details/'
				break;
		}
		return endpoint;

	}

	//MODAL CONTENT
	$( document ).on( 'click', '.ub-modal', function( e ) {
		e.preventDefault();
		const $this = $( this );
		const olClass = $this.data( 'class' );
		if ( $this.data( 'modal-content' ) ) {
			addOverlay( $this.data( 'modal-content' ) );
		} else if ( $this.data( 'action' ) ) {
			
			$.ajax( {
				type: 'POST',
				url: ubData.rest_root + get_registration_rest_endpoint( $this.data( 'action' )),
				dataType: 'json',
				data: {
					action: $this.data( 'action' ),
					atts: $this.data(),
					pid: $('#custrecord_wproduct').val(),
					mid: $('#custrecord_wmodelnumber').val(),
				},
				success( data ) {
					addOverlay( data.html );
				},
			} );
		}
	} );

	$('body').on('added_to_cart', function(){
		if($('.overlay').length){
			removeOverlay();
		}
	})

	$( document ).on( 'click', '.overlay', function( e ) {
		if($(this).hasClass('overlay')) return;
		if ( e.target == this ) {
			removeOverlay();
		}
	} );
	$( document ).on( 'click', '.overlay__close-btn', function( e ) {
		removeOverlay( $(this) );
	} );

	$(window).on('resize', debounce(function () {
		console.log('ableplayering');
		$('.able-player').each(function () {
			if ($(this).data('ablePlayer')) {
				$(this).data('ablePlayer').destroy();
			}

			new AblePlayer($(this));
		});
	}, 300));
	function debounce(func, wait) {
		let timeout;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(func, wait);
		};
	}

	// shop listing filter
	$(".filters__section button").click(function(e){
		e.preventDefault();
		if( $(this).attr("aria-expanded") == "true" ){
			$(this).attr("aria-expanded", "false");			
		}else{
			$(this).attr("aria-expanded", "true");
		}
	});

} );

function addWaiting( applyTo = 'body' ) {
	removeOverlay();
	let cls = 'overlay';
	if ( applyTo != 'body' ) {
		cls += ' relative';
	}
	jQuery( applyTo ).append( '<div class="' + cls + '"><div class="overlay__waiting"><img src="/wp-content/themes/uppababy/assets/img/loading-icon-v1.svg" /></div>' );
}

function addOverlay(content = '', olClass = '', shouldRemoveOverlay = true) { 
	if(shouldRemoveOverlay){
		removeOverlay();
	}

    const overlay = document.createElement('div');
    overlay.className = `overlay ${olClass}`;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-labelledby', 'popup-title');
    overlay.setAttribute('tabindex', '-1');

    overlay.innerHTML = `
        <div class="overlay__wrapper">
            <div class="overlay__close">
                <button class="overlay__close-btn close link" name="confirm-products" value="true">
                    <img src="/wp-content/themes/uppababy/assets/img/close-tiny-dark.svg" class="close__img" alt="close" />
                </button>
            </div>
            <div class="overlay__content">${content}</div>
        </div>
    `;

    jQuery('body').append(overlay);

    overlay.querySelector('.overlay__close-btn').focus();

}

function removeOverlay( $this = null ) {
	if( $this != null ){
		let $overlay = $this.closest('.overlay'); 
		if( $overlay.hasClass( 'fine-print') && $overlay.prev('div').hasClass('overlay-quickview') ){
			$overlay.remove()
		}
		else
			jQuery( '.overlay' ).remove();
	}else{
		jQuery( '.overlay' ).remove();
	}
}
function removeMessages() {
	jQuery( '.ub-messages' ).remove();
}

function is_int( value ) {
	if ( parseFloat( value ) == parseInt( value ) && ! isNaN( value ) ) {
		return true;
	}
	return false;
}

function ubValidateFieldRequired($field){
	var $input=$field.find('input, select, radio');
	$field.find('div.ub-messages-errors').remove();

	var errors=false;
	var hasRequiredAttribute = ( typeof $input.attr('required') !== 'undefined' || $field.hasClass('validate-required') || $field.hasClass('required') );

	isFieldEmpty = $input.is('select') ? ($input.val() === null || $input.val() === '' || $input.val() === undefined) : ( $input.val()== '' || $input.val() == undefined );

	if( hasRequiredAttribute && isFieldEmpty && !$input.hasClass('hidden') && !$field.hasClass('hidden')){
		$input.addClass('error');
		var label=$field.find('label').text();
		// jQuery('<div class="ub-messages ub-messages-errors"><p class="error">'+label+' is required</p></div>').insertAfter($input);
		if( label !== "" ){
			var errMessage = '<div class="ub-messages ub-messages-errors"><p class="error">'+label+' field is required</p></div>';
			$field.append(errMessage);
			errors=true;
		}
	}
	return errors;
}

// Avoid submitting form by pressing "Enter" key on the gravity form swatch selection template
jQuery(document).on('keydown', '.page-template-template-swatches-2020 form#gform_5', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
		return false;
    }
});

/**
 * Open the cookies setting popup with accessibility attributes
 *
 * @return void
 */
document.addEventListener('DOMContentLoaded', function () {
	const triggerElements = document.querySelectorAll('.ot-sdk-show-settings');

	if (triggerElements.length > 0) {
		triggerElements.forEach(function (triggerElement) {
			// Ensure the element is focusable for accessibility
			triggerElement.setAttribute('tabindex', '0');
			triggerElement.setAttribute('role', 'button');
			triggerElement.setAttribute('aria-label', ubData.cookies_accessibility_text);

			// Add event listener for keydown
			triggerElement.addEventListener('keydown', function (event) {
				// Check if the pressed key is Enter (13) or Space (32)
				if (['Enter', ' '].includes(event.key) || event.keyCode === 13 || event.keyCode === 32) {
					event.preventDefault(); // Prevent default scrolling on Space
					triggerElement.click(); // Simulate click
				}
			});
		});
	}

});

